<template>
	<problem-view />
</template>

<script>

import ProblemView from '@/components/shared/ProblemView';

export default {
	name: 'unresolved',
	components: {
		ProblemView,
	},
};
</script>



// WEBPACK FOOTER //
// Unresolved.vue?8653d8d6